const varType = require("./common/varType.cjs");
const configAll = require("./configAll.cjs");
const { Config } = configAll;

const base64encodechars =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const base64decodechars = [
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60,
  61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,
  14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26,
  27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
  46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1,
];

function base64encode(str) {
  let out;
  let i;
  const len = str.length;
  let c1;
  let c2;
  let c3;
  i = 0;
  out = "";
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff;
    if (i === len) {
      out += base64encodechars.charAt(c1 >> 2);
      out += base64encodechars.charAt((c1 & 0x3) << 4);
      out += "==";
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i === len) {
      out += base64encodechars.charAt(c1 >> 2);
      out += base64encodechars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
      out += base64encodechars.charAt((c2 & 0xf) << 2);
      out += "=";
      break;
    }
    c3 = str.charCodeAt(i++);
    out += base64encodechars.charAt(c1 >> 2);
    out += base64encodechars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
    out += base64encodechars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
    out += base64encodechars.charAt(c3 & 0x3f);
  }
  return out;
}
function base64decode(str) {
  let c1;
  let c2;
  let c3;
  let c4;
  let i;
  const len = str.length;
  let out;
  i = 0;
  out = "";
  while (i < len) {
    do {
      c1 = base64decodechars[str.charCodeAt(i++) & 0xff];
    } while (i < len && c1 === -1);
    if (c1 === -1) {
      break;
    }
    do {
      c2 = base64decodechars[str.charCodeAt(i++) & 0xff];
    } while (i < len && c2 === -1);
    if (c2 === -1) {
      break;
    }
    out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));
    do {
      c3 = str.charCodeAt(i++) & 0xff;
      if (c3 === 61) {
        return out;
      }
      c3 = base64decodechars[c3];
    } while (i < len && c3 === -1);
    if (c3 === -1) {
      break;
    }
    out += String.fromCharCode(((c2 & 0xf) << 4) | ((c3 & 0x3c) >> 2));
    do {
      c4 = str.charCodeAt(i++) & 0xff;
      if (c4 === 61) {
        return out;
      }
      c4 = base64decodechars[c4];
    } while (i < len && c4 === -1);
    if (c4 === -1) {
      break;
    }
    out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
  }
  return out;
}

// 生成UUID
function generateUUID() {
  let d = this.newTimeStamp();
  const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

// 小于10加0处理
function addZero(e) {
  return Number(e) < 10 ? `0${e}` : `${e}`;
}

// new 一个时间戳:无参返回当前时间戳,有参返回传入时间的时间戳
function newTimeStamp(dateIn) {
  if (!dateIn) {
    return new Date().getTime();
  } else {
    const newDate = varType.isDate(dateIn) ? dateIn : new Date(dateIn);
    return newDate.getTime();
  }
}

// 时间格式化
const formatDate = (dateIn, fmt) => {
  if (!fmt) return false;
  if (varType.isString(dateIn)) {
    dateIn = dateIn.replace(/\./g, "/");
    dateIn = dateIn.replace(/-/g, "/");
  }
  const newDate = varType.isDate(dateIn) ? dateIn : new Date(dateIn);
  const o = {
    "y+": newDate.getFullYear(), // 年份
    "M+": addZero(newDate.getMonth() + 1), // 月份
    "d+": addZero(newDate.getDate()), // 某一天
    "h+": addZero(newDate.getHours()), // 小时
    "m+": addZero(newDate.getMinutes()), // 分钟
    "s+": addZero(newDate.getSeconds()), // 秒
  };
  for (const i in o) {
    if (new RegExp("(" + i + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, o[i]);
    }
  }
  return fmt;
};

// 时间格式化
function formatDateTime(dateTime) {
  const newDate = dateTime ? new Date(dateTime.replace(/-/g, "/")) : new Date();
  const year = newDate.getFullYear();
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const weekDay = transWeekDay(newDate.getDay());
  const hour = addZero(newDate.getHours());
  const hour12 = hour >= 12 ? addZero(hour - 12) : hour;
  const minute = addZero(newDate.getMinutes());
  const second = addZero(newDate.getSeconds());
  return {
    year,
    month,
    day,
    weekDay,
    hour,
    hour12,
    minute,
    second,
  };
}

// 将weekday转换成星期几
function transWeekDay(e) {
  return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"][
    e
  ];
}

// 处理相对路径url问题。为相对路径增加host头，如果是绝对路径则不需要再添加
function dealRelativeUrl(url, hostToAdd) {
  if (!url) {
    return "";
  }
  if (!hostToAdd) {
    return url;
  }
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  // 移除最后的/
  hostToAdd =
    hostToAdd.substring(hostToAdd.length - 1) === "/"
      ? hostToAdd.substring(0, hostToAdd.length - 1)
      : hostToAdd;
  return hostToAdd + "/" + url;
}

// 浅拷贝
function shallowCopy(obj) {
  if (obj === null) {
    return null;
  } else {
    return Object.create(
      Object.getPrototypeOf(obj),
      Object.getOwnPropertyDescriptors(obj)
    );
  }
}

// 深拷贝
function deepCopy(obj, clone = Array.isArray(obj) ? [] : {}) {
  if (obj != null && typeof obj === "object") {
    for (const [key, value] of Object.entries(obj)) {
      clone[key] = deepCopy(value);
    }
  } else {
    clone = obj;
  }
  return clone;
}

// scrollTo: type目前针对返回kbwIndex的focus效果适配
function scrollToY(y, type) {
  window.scrollTo({
    top: type ? y - 30 : y,
    behavior: "instant",
  });
}

function scrollTo(dom, x, y) {
  dom && dom.scrollTo(x, y);
}



// 获取视频对象的属性
function getVideoAttr(videoObj) {
  const {
    audioTracks, // 返回表示可用音频轨道的 AudioTrackList 对象。
    autoplay, // 设置或返回是否在就绪（加载完成）后随即播放视频。
    buffered, // 返回视频已缓存部分的TimeRanges对象
    controller, // 返回表示视频当前媒体控制器的MediaController对象
    controls, // 设置或返回视频是否应该显示控件（比如播放/暂停等）。
    crossOrigin, // 设置或返回视频的CORS设置
    currentSrc, // 返回当前视频的URL
    currentTime, // 设置或返回视频中的当前播放位置
    defaultMuted, // 设置后返回视频默认是否静音
    defaultPlaybackRate, // 设置或返回视频的默认播放速度。
    duration, // 返回视频的长度
    ended, // 返回视频的播放是否已经结束
    error, // 返回表示视频错误状态的MeidaError对象
    height, // 设置或返回视频的 height 属性的值。
    loop, // 设置或返回视频是否应在结束时再次播放。
    mediaGroup, // 设置或返回视频所属媒介组合的名称。
    muted, // 设置或返回是否关闭声音。
    networkState, // 返回视频的当前网络状态。
    paused, // 设置或返回视频是否暂停。
    playbackRate, // 设置或返回视频播放的速度。
    played, // 返回表示视频已播放部分的 TimeRanges 对象。
    poster, // 设置或返回视频的 poster 属性的值。
    preload, // 设置或返回视频的 preload 属性的值。
    readyState, // 返回视频当前的就绪状态。
    seekable, // 返回表示视频可寻址部分的 TimeRanges 对象。
    seeking, // 返回用户当前是否正在视频中进行查找。
    src, // 设置或返回视频的 src 属性的值。
    startDate, // 返回表示当前时间偏移的 Date 对象。
    textTracks, // 返回表示可用文本轨道的 TextTrackList 对象。
    videoTracks, // 返回表示可用视频轨道的 VideoTrackList 对象。
    volume, // 设置或返回视频的音量。
    width, // 设置或返回视频的 width 属性的值。
  } = videoObj;
  return {
    audioTracks,
    autoplay,
    buffered,
    controller,
    controls,
    crossOrigin,
    currentSrc,
    currentTime,
    defaultMuted,
    defaultPlaybackRate,
    duration,
    ended,
    error,
    height,
    loop,
    mediaGroup,
    muted,
    networkState,
    paused,
    playbackRate,
    played,
    poster,
    preload,
    readyState,
    seekable,
    seeking,
    src,
    startDate,
    textTracks,
    videoTracks,
    volume,
    width,
  };
}

// 观察者
const domWatch = function (domObj, callback) {
  return new DomWatchClass(domObj, callback);
};
const DomWatchClass = function (domObj, callback) {
  const domObserver = new MutationObserver(callback);
  const option = {
    childList: true, // 子节点的变动
    attributes: false, // 属性的变动
    subtree: true,
    characterData: true, // 节点内容或节点文本的变动
  };
  domObserver.observe(domObj, option);
  this.tempObj = domObserver;
  this.disconnect = function () {
    this.tempObj.disconnect();
  };
};

// 检查浏览器内核
function checkKernel() {
  // 采用惰性匹配
  const kernelArr = navigator.userAgent.match(/\s.*?\//g);
  // 取出内核名称
  const kernelLast = kernelArr[kernelArr.length - 1].split("/")[0];
  // 去除空格并小写
  const kernel = kernelLast.replace(/\s/, "").toLowerCase();
  return kernel;
}

// 获取窗口的宽度和高度: 包含滚动条
function getWindowHeightWidth() {
  if (!Config.windowWH.windowW) {
    Config.windowWH = {
      windowW: window.innerWidth || document.documentElement.clientWidth,
      windowH: window.innerHeight || document.documentElement.clientHeight,
    };
  }
  return Config.windowWH;
}

// 获取当前滚动条位置
function getScrollTop() {
  const top =
    document.documentElement && document.documentElement.scrollTop
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
  return top;
}

// 窗口打开
function windowOpen(url = "./", name = "_blank") {
  if (!url) {
    return false;
  }
  window.open(url, name);
}

/* eslint-disable */
windowOpen = interceptor(windowOpen, {
  beforeCall(args) {
    let canRun = true;
    const path = args[0].split("?")[0];
    switch (path) {
      case "/ipDetail":
        canRun = false;
        break;
      default:
        canRun = true;
        break;
    }
    return canRun;
  },
});
/* eslint-enable */

// 函数拦截
function interceptor(fn, { beforeCall = null }) {
  return function (...args) {
    if (!beforeCall || beforeCall.call(this, args) !== false) {
      const ret = fn.apply(this, args);
      return ret;
    }
  };
}

function reFresh(url) {
  if (url) {
    // window.location.replace(url)
  } else {
    window.location.reload();
  }
}

function goLogin() {
  reFresh(Config.loginPath || "/login");
}

// 字符串去空格
function trim(str) {
  // 替换所有的&nbsp;成为空格
  str = str.replace(/&nbsp;(\s*)/g, " ");
  // 首尾去空格
  str = str.replace(/(^\s*)|(\s*$)/g, "");
  return str;
}

/**
 * 防抖:只会执行一次点击事件
 * @param {function} fn
 * @param {number} wait time
 * @param {boolean} immediate
 * @returns function
 */
const debounce = (fn, wait, immediate) => {
  let timeout = debounce.timeout;
  // timeout的值利用了闭包特性
  return function (...args) {
    // this指向上下文关联的dom
    const context = this;
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      const callNow = !timeout;
      // 倒计时结束释放内存
      debounce.timeout = setTimeout(() => {
        timeout = null;
      }, wait);
      // 要绑定触发事件,因此使用apply而不是call
      if (callNow) fn.apply(context, args);
    } else {
      debounce.timeout = setTimeout(() => {
        fn.apply(context, args);
      }, wait);
    }
  };
};

/**
 * 节流: 时间间隔内只执行一次
 * @param {function} fn
 * @param {number} wait
 * @returns object
 */
const throttle = (fn, wait) => {
  let last = throttle.last || 0;
  let timeout = throttle.timeout;
  let waitCallback = throttle.waitCallback;
  // 利用arguments传递参数
  const newFn = function (...arg) {
    const now = Date.now();
    clearTimeout(timeout);
    // 时间间隔未到,设定定时器触发,return跳过当前次的callback函数
    if (now - last < wait) {
      throttle.timeout = setTimeout(waitCallback, wait - (now - last));
      return;
    }
    // 会存在变量提升,前后不重要，放在后面主要方便理解
    throttle.waitCallback = () => {
      throttle.waitCallback = null;
      throttle.last = now;
      // 这个this指向全局,也就是window
      fn.apply(this, arg);
    };
    waitCallback && waitCallback();
  };
  // 取消执行
  newFn.cancel = function () {
    clearTimeout(timeout);
    throttle.waitCallback = null;
  };
  // 立即执行
  newFn.flush = function () {
    clearTimeout(timeout);
    waitCallback && waitCallback();
  };
  return newFn;
};

// swiper点击事件hack:由于loop等于true，克隆节点无事件响应
function swiperClickEventHaijack(className, cb) {
  const indexAllArr = document.querySelectorAll(className);
  for (let i = 0; i < indexAllArr.length; i++) {
    indexAllArr[i].addEventListener("click", function (e) {
      cb(Number(e.target.dataset.currentidx));
    });
  }
}

/**
 * 默认生成最近7天的日期选择
 * @returns [startStr, endStr]
 */
function renderLatest7DateTime() {
  const end = newTimeStamp();
  const start = end - 3600 * 1000 * 24 * 7;
  const endStr = formatDate(end, "yyyy-MM-dd hh:mm:ss");
  const startStr = formatDate(start, "yyyy-MM-dd hh:mm:ss");
  return [startStr, endStr];
}

/**
 * 判断时间选择时间与当前时间是否超过90天
 * @param {*} startTime 开始时间
 * @param {*} defaultDay 90
 * @returns Boolean
 */
function judgeDateTimeOverDays(startTime, defaultDay = 90) {
  const now = newTimeStamp();
  const startTimeStamp = newTimeStamp(startTime);
  return now - 3600 * 1000 * 24 * defaultDay > startTimeStamp;
}

/**
 * 比较俩个时间小于或小于等于
 * @param {*} startTime
 * @param {*} endTime
 * @param {*} type 1：小于; 2: 小于等于
 * @returns
 */
function compareTowTimeSmall(startTime, endTime, type = 1) {
  let result = true;
  switch (type) {
    case 1:
      result = newTimeStamp(startTime) < newTimeStamp(endTime);
      break;
    case 2:
      result = newTimeStamp(startTime) <= newTimeStamp(endTime);
      break;
    default:
      break;
  }
  return result;
}

/**
 * 生成设备管理-默认视图设置
 * @returns object
 */
function renderMonitorDefaultViewSet() {
  return {
    macInstanceId: false, // 餐柜ID
    machineNo: true, // 餐柜编号
    macType: false, // 餐柜类型
    macModeInMac: true, // 设备模式
    macStatus: true, // 设备状态
    connectStatus: true, // 网络状态
    workOrder: true, // 工单
    machDoor: true, // 门状态
    boilState: true, // 锅炉状态
    coldState: true, // 冷藏状态
    reposQtyDtoList: false, // 库存
    isFeed: true, // 是否上料
  };
}

/**
 * 压缩图片比例, 25%和50%
 * @param {*} url
 * @param {*} type
 * @returns string
 */
const compressImg = (url, type = 0.25) => {
  let value = 25;
  if (varType.isNumber(type)) {
    value = type * 100;
  }
  return `${url}?x-oss-process=image/resize,p_${value}`;
};

/**
 * 长边压缩, value越大,图片越大
 * @param {*} url
 * @param {*} value
 * @returns string
 */
const compressImgLongLine = (url, value = 200) => {
  return `${url}?x-oss-process=image/resize,l_${value}`;
};

/**
 * 随机生成唯一字符串: env-timestamp-string
 * @returns string
 */
const randomUniqueKey = (env = Config.runEnv) => {
  const timestamp = newTimeStamp();
  const letter1 = randomStrFromCharCode();
  const letter2 = randomStrFromCharCode();
  return `${env}-${timestamp}-${letter1}${letter2}`;
};

/**
 * 随机生成字母数字
 * @returns string 包含字母、数字
 */
const randomStrFromCharCode = () => {
  // a-z 97-122
  const start1 = 97;
  const end1 = 122;
  // A-Z 65-90
  const start2 = 65;
  const end2 = 90;
  // 0-9 45-57
  const start3 = 45;
  const end3 = 57;
  const typeNum = Math.ceil(Math.random() * 3);
  const codeNum1 = Math.floor(start1 + Math.random() * (end1 - start1));
  const codeNum2 = Math.floor(start2 + Math.random() * (end2 - start2));
  const codeNum3 = Math.floor(start3 + Math.random() * (end3 - start3));
  let code = "";
  switch (typeNum) {
    case 1:
      code = String.fromCharCode(codeNum1);
      break;
    case 2:
      code = String.fromCharCode(codeNum2);
      break;
    case 3:
      code = String.fromCharCode(codeNum3);
      break;
    default:
      break;
  }
  return code;
};

/**
 * 截取工单id
 * @param {*} val
 * @returns
 */
const getWorkOrderId = (val) => {
  const str = val;
  if (str.includes("-")) {
    const workOrderid = str.split("-")[1];
    return workOrderid;
  } else {
    const workOrderid = str;
    return workOrderid;
  }
};

/**
 * 克隆规格数据, 添加idx
 * @param {*} dataObj
 * @param {*} idx
 * @returns
 */
const cloneSpecDataByDifferentIdx = (dataObj, idx) => {
  let tempObj = {};
  const keys = Object.keys(dataObj).forEach((li) => {
    tempObj[`${li}-${idx}`] = dataObj[li];
  });
  return tempObj;
};

/**
 * 递归生成规格组合列表
 * @param {*} arrays 规格参数列表
 * @returns Array
 */
const combineSpecNames = (arrays) => {
  let idx = 0;
  return arrays.reduce(
    (acc, curr) => {
      idx += 1;
      // 一维展开
      return acc.flatMap((a) => {
        return curr.map((b) => {
          return {
            ...a,
            ...cloneSpecDataByDifferentIdx(b, idx),
          };
        });
      });
    },
    [{}]
  ); // 初始值为一个默认规格对象，以便开始组合
};

/**
 * 计算上下架时间方法
 * @param {*} start
 * @param {*} end
 * @param {*} align
 * @returns
 */
const formatRange = (start, end, align) => {
  // 补严谨校验
  if (!start || !end || !align) return "";
  // 提取年份
  const alignYear = Number(align.split("-")[0]);
  if (alignYear > 2028) {
    return "长期";
  } else {
    const format = (val) => {
      const [date, time] = val.split(" ");
      if (!date || !time) return "";
      const [, month, day] = date.split("-");
      const [hour, minute] = time.split(":");
      return `${month}/${day} ${hour}:${minute}`;
    };
    return `${format(start)} - </br>${format(end)}`;
  }
};

/**
 * 计算上下架时间方法
 * @param {*} start
 * @param {*} end
 * @param {*} align
 * @returns
 */
const formatRangeGroundTime = (time) => {
  // 补严谨校验
  if (!time) return "";
  const format = (val) => {
    const [date, time] = val.split(" ");
    if (!date || !time) return "";
    const [, month, day] = date.split("-");
    const [hour, minute] = time.split(":");
    return `${month}/${day} ${hour}:${minute}`;
  };
  return format(time);
};
/**
 * 判断标准json
 * @param {*} raw
 * @returns
 */
const parseFlexibleArr = (raw) => {
  if (typeof raw !== "string") return [];
  let arr = [];
  try {
    arr = JSON.parse(raw);
    if (!Array.isArray(arr)) arr = [arr];
  } catch (e) {
    // 不是 JSON，兜底用逗号分隔
    arr = raw.split(",");
  }
  return arr.map((v) => String(v).trim()).filter((v) => v); // 清理空值
};

const UtilFn = {
  varType,
  addZero,
  base64encode,
  base64decode,
  generateUUID,
  newTimeStamp,
  formatDate,
  formatDateTime,
  transWeekDay,
  dealRelativeUrl,
  shallowCopy,
  deepCopy,
  scrollToY,
  debounce,
  throttle,
  getVideoAttr,
  domWatch,
  checkKernel,
  scrollTo,
  getWindowHeightWidth,
  getScrollTop,
  windowOpen,
  reFresh,
  goLogin,
  trim,
  swiperClickEventHaijack,
  interceptor,
  renderLatest7DateTime,
  judgeDateTimeOverDays,
  compareTowTimeSmall,
  renderMonitorDefaultViewSet,
  compressImg,
  compressImgLongLine,
  randomUniqueKey,
  randomStrFromCharCode,
  getWorkOrderId,
  combineSpecNames,
  formatRange,
  formatRangeGroundTime,
  parseFlexibleArr,
};

module.exports = UtilFn;
